import { useTranslation } from 'hooks';
import { isEmpty, isNil, map, toLower, toString } from 'lodash';
import Link from 'next/link';
import { DetailPageContext } from 'pages/[ket-qua-tim-kiem]/[chi-tiet-tin-rao]';
import { useContext } from 'react';

const SameInDistrictList = () => {
  const { realEstate, nearRealEstatesByWard } = useContext(DetailPageContext).pageData ?? {};
  const { isForSell, district, type } = realEstate ?? {};
  const translation = useTranslation();

  return isEmpty(nearRealEstatesByWard) ? null : (
    <div
      id='same-in-district-list'
      className='flex flex-col space-y-[16px] rounded-[16px] bg-paper px-[24px] py-[28px] shadow-1'
    >
      <span className='text-[16px] font-[600] leading-[20px]'>
        {`${isNil(isForSell) ? '' : (translation.major.isForSell as any)[toString(isForSell)]}${
          type
            ? ` ${toLower(
                (isForSell
                  ? translation.major.forSellRealEstateType
                  : (translation.major.forRentRealEstateType as any))[type],
              )}`
            : ''
        }${district ? ` ${district?.name}` : ''}`}
      </span>
      <div>
        <div className='m-[-8px] flex flex-wrap'>
          {map(nearRealEstatesByWard, (nearRealEstateByWard, nearRealEstateByWardIndex) => (
            <div
              key={`${nearRealEstateByWard.wardId}-${nearRealEstateByWardIndex}`}
              className='w-1/2 p-[8px]'
            >
              <Link
                href={isNil(nearRealEstateByWard?.slug) ? '#' : `/${nearRealEstateByWard?.slug}`}
              >
                <span className='text-primary'>{`${
                  nearRealEstateByWard.wardName
                } (${nearRealEstateByWard.total?.toLocaleString()})`}</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SameInDistrictList;
